export const GET_XP_LEADERBOARD_MONTH = 'GET_XP_LEADERBOARD_MONTH';
export const GET_XP_LEADERBOARD_WEEK = 'GET_XP_LEADERBOARD_WEEK';
export const GET_XP_LEADERBOARD_CHANNEL = 'GET_XP_LEADERBOARD_CHANNEL';
export const GET_BK_LEADERBOARD_WEEK = 'GET_BK_LEADERBOARD_WEEK';
export const GET_BK_LEADERBOARD_MONTH = 'GET_BK_LEADERBOARD_MONTH';
export const GET_BK_LEADERBOARD_CHANNEL = 'GET_BK_LEADERBOARD_CHANNEL';